import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { ServicingSection } from 'web-ui-components/lib/global/layout';
import { ButtonGroup } from 'web-ui-components/lib/molecules/buttons';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import { updateValidation, hideErrorMsg, deleteValidationField } from '../../../states/validation/actions';
import { getValidationRowState, isSpecificFormValid } from '../../../states/validation/selectors';
import {
	updateAddPayeeForm,
	resetAddPayeeForm,
	resetAddPayeeFormErrors,
	setGenericError,
} from '../../states/addPayee/actions';
import {
	getLinkAccountDetails,
	getAddPayeeFormDetails,
	getErrors,
	getEditPayeeButtonStatus,
	getFromAccountId,
	showSingleUseBox,
	showChapsCheckBox,
	isValidChapsCharsFormat,
} from '../../states/addPayee/selectors';
import {
	validationPropTypes,
	addPayeeFormPropTypes,
	linkAccountDetailsPropTypes,
	errorsPropTypes,
} from '../../states/addPayee/propTypes';
import { getBankId, getClientContext } from '../../../states/session/selectors';
import { addPayeeFormFormatter, spacesCheck } from '../../../utils/payeeUtils';
import pageContent from '../AddNewPayeeLandingPage/index.content';
import AddPayeeFormErrors from './AddPayeeFormErrors';
import withContent from '../../../containers/withContent';
import { goBackPage } from '../../../states/page/actions';
import { getSourceAccountId } from '../../../managePayee/states/selectors';
import { hasApiCallInProgress } from '../../../states/api/selectors';
import { getApiBaseUrlPaas } from '../../../states/envConfig/selectors';
import { addPayeeFormLengths } from '../../../config';
import COPType from './COPType';
import { PageHeading, SubsectionHeading } from 'web-ui-components/lib/typography/headings';

const mapState = (state, props) => ({
	validations: getValidationRowState(state, props.id),
	addPayeeForm: getAddPayeeFormDetails(state),
	formValid: isSpecificFormValid(state, props.id),
	linkAccountDetails: getLinkAccountDetails(state),
	bankId: getBankId(state),
	errors: getErrors(state),
	sourceAccountId: getSourceAccountId(state),
	isEditPayeeButtonDisabled: getEditPayeeButtonStatus(state),
	clientContext: getClientContext(state),
	apiBaseUrlPaas: getApiBaseUrlPaas(state),
	hasApiCallInProgress: hasApiCallInProgress(state),
	fromAccountId: getFromAccountId(state),
	showSingleUseBox: showSingleUseBox(state, props.isEditPayee),
	showChapsCheckBox: showChapsCheckBox(state, props.isFromChapsPayment),
	isValidChapsCharsFormat: isValidChapsCharsFormat(state, true),
});

const mapDispatch = (dispatch, props) => ({
	updateValidation: (key, isValid, isFocusOn, isBackEndError, showValidation) =>
		dispatch(updateValidation({ id: props.id, key, isValid, isFocusOn, isBackEndError, showValidation })),
	hideErrorMsg: (key) => dispatch(hideErrorMsg({ id: props.id, key })),
	updateAddPayeeForm: (value) => dispatch(updateAddPayeeForm(value)),
	deleteValidationField: (id, fieldId) => dispatch(deleteValidationField(id, fieldId)),
	resetAddPayeeForm: () => dispatch(resetAddPayeeForm(props.id)),
	resetAddPayeeFormErrors: () => dispatch(resetAddPayeeFormErrors()),
	goBackPage: () => dispatch(goBackPage()),
	setGenericError: (errorCode) => dispatch(setGenericError(errorCode)),
});
export class AddPayeeFormWithTrusted extends Component {
	constructor(props) {
		super(props);
		this.updateAddPayeeForm = this.updateAddPayeeForm.bind(this);
		this.handleSingleUseChange = this.handleSingleUseChange.bind(this);
		this.handleChapsPaymentsEnableChange = this.handleChapsPaymentsEnableChange.bind(this);
		this.state = {
			showMoreInfo: false,
		};
		this.handleAddPayeeSubmit = this.handleAddPayeeSubmit.bind(this);
		this.updateSortCodeAndAccountValidation = this.updateSortCodeAndAccountValidation.bind(this);
	}

	componentWillReceiveProps(newProps) {
		const {
			errors: { showError },
		} = this.props;
		const isBackEndError = newProps.errors.showError && !showError;
		if (isBackEndError && window && window.scrollTo) {
			window.scrollTo(0, 0);
		}
	}

	componentWillUnmount() {
		const { resetAddPayeeForm } = this.props;
		// resetAddPayeeForm();
	}

	updateAddPayeeForm(event) {
		const { updateAddPayeeForm, addPayeeForm } = this.props;
		const {
			target: { id, value },
		} = event;
		const formattedValue = addPayeeFormFormatter[id] ? addPayeeFormFormatter[id](event, addPayeeForm) : value;
		if (addPayeeForm[id] !== formattedValue) {
			updateAddPayeeForm({ [id]: formattedValue });
		}
	}

	handleSingleUseChange({ target }) {
		const { updateAddPayeeForm, deleteValidationField, id } = this.props;
		updateAddPayeeForm({ [target.id]: !target.checked });
		deleteValidationField(id, 'displayName');
	}

	handleChapsPaymentsEnableChange({ target: { id, checked } }) {
		const {
			updateAddPayeeForm,
			deleteValidationField,
			updateValidation,
			addPayeeForm: { name },
			isValidChapsCharsFormat,
			setGenericError,
		} = this.props;
		updateAddPayeeForm({ [id]: checked });
		const chapsNameValid = name.length <= addPayeeFormLengths.chapsName;
		const nameValid = name.length <= addPayeeFormLengths.name;
		if (checked) {
			if (!chapsNameValid) updateValidation('name', chapsNameValid, true, false, true);
			if (!isValidChapsCharsFormat) {
				window.scrollTo(0, 0);
				setGenericError('incorrectDetailsForChaps');
			}
			updateAddPayeeForm({ reference: '', payeeCountry: 'GB' });
			deleteValidationField(this.props.id, ['reference']);
		} else {
			updateValidation('name', nameValid);
			updateAddPayeeForm({
				chapsReference: '',
				payeeAddressLine1: '',
				payeeAddressLine2: '',
				payeePostalCode: '',
				payeeCity: '',
				payeeCountry: '',
				reference: '',
			});
			deleteValidationField(this.props.id, ['payeeAddressLine1', 'payeeCity', 'payeeCountry', 'reference']);
		}
	}

	handleAddPayeeSubmit() {
		const { resetAddPayeeFormErrors, handleAddPayeeSubmit } = this.props;
		resetAddPayeeFormErrors();
		handleAddPayeeSubmit();
	}

	updateSortCodeAndAccountValidation(key, isValid, isFocusOn, isBackEndError, showValidation) {
		const { updateValidation, validations } = this.props;

		if (
			get(validations, 'accountNumber.errorCode', '') === '027' &&
			get(validations, 'accountNumber.isValid') === false
		) {
			updateValidation('accountNumber', true, isFocusOn, false, false);
			updateValidation('sortCode', true, isFocusOn, false, false);
		} else {
			updateValidation(key, isValid, isFocusOn, isBackEndError, showValidation);
		}
	}

	render() {
		const {
			content: { header, editPayeeHeader, cancelButtonLabel, continueButtonText, subheader },
			validations,
			updateValidation,
			hideErrorMsg,
			addPayeeForm,
			updateAddPayeeForm,
			errors,
			resetAddPayeeFormErrors,
			goBackPage,
			isEditPayee,
			isEditPayeeButtonDisabled,
			hasApiCallInProgress,
			id,
		} = this.props;
		const validationProps = {
			validations,
			updateValidation,
			hideErrorMsg,
			onChange: this.updateAddPayeeForm,
			onFocusCheck: false,
		};
		const { copType } = addPayeeForm;
		if (!Object.keys(addPayeeForm).length) {
			return null;
		}

		return (
			<ServicingSection>
				<BackButton onClick={goBackPage} disabled={hasApiCallInProgress} />
				<PageHeading data-test-id="add-payee-trusted">{isEditPayee ? editPayeeHeader : header}</PageHeading>
				<SubsectionHeading>{subheader}</SubsectionHeading>

				{errors.showError && (
					<AddPayeeFormErrors errorCode={errors.errorCode} resetAddPayeeFormErrors={resetAddPayeeFormErrors} />
				)}
				<COPType
					id="copType"
					label={'copType'}
					type="text"
					description={'description'}
					copType={copType}
					value={copType}
					{...validationProps}
					updateAddPayeeForm={updateAddPayeeForm}
					propId={id}
				/>
				<ButtonGroup>
					<Button display="secondary" width="flush" onClick={goBackPage} disabled={hasApiCallInProgress}>
						{cancelButtonLabel}
					</Button>
					<Button
						display="primary"
						width="flush"
						onClick={this.handleAddPayeeSubmit}
						disabled={isEditPayee && isEditPayeeButtonDisabled}
						isLoading={hasApiCallInProgress}
					>
						{continueButtonText}
					</Button>
				</ButtonGroup>
			</ServicingSection>
		);
	}
}

AddPayeeFormWithTrusted.propTypes = {
	id: PropTypes.string.isRequired,
	content: PropTypes.shape({}).isRequired,
	accountsForAddPayee: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			value: PropTypes.string.isRequired,
		})
	).isRequired,
	validations: PropTypes.shape(validationPropTypes).isRequired,
	updateValidation: PropTypes.func.isRequired,
	hideErrorMsg: PropTypes.func.isRequired,
	updateAddPayeeForm: PropTypes.func.isRequired,
	addPayeeForm: PropTypes.shape(addPayeeFormPropTypes).isRequired,
	formValid: PropTypes.bool.isRequired,
	isEditPayee: PropTypes.bool,
	isPaymentFlow: PropTypes.bool,
	linkAccountDetails: PropTypes.shape(linkAccountDetailsPropTypes).isRequired,
	bankId: PropTypes.string.isRequired,
	deleteValidationField: PropTypes.func.isRequired,
	errors: errorsPropTypes,
	resetAddPayeeForm: PropTypes.func.isRequired,
	resetAddPayeeFormErrors: PropTypes.func.isRequired,
	goBackPage: PropTypes.func.isRequired,
	handleAddPayeeSubmit: PropTypes.func.isRequired,
	sourceAccountId: PropTypes.string.isRequired,
	isEditPayeeButtonDisabled: PropTypes.bool.isRequired,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	clientContext: PropTypes.shape({}).isRequired,
	apiBaseUrlPaas: PropTypes.string.isRequired,
	fromAccountId: PropTypes.string.isRequired,
	showSingleUseBox: PropTypes.bool.isRequired,
	showChapsCheckBox: PropTypes.bool.isRequired,
	isValidChapsCharsFormat: PropTypes.bool.isRequired,
	setGenericError: PropTypes.func.isRequired,
};

export default connect(mapState, mapDispatch)(withContent({ content: pageContent })(AddPayeeFormWithTrusted));
